import React from 'react';
import { Box } from '@mui/material';
import { balancedColumns, useElementSize } from '../utils/layoutHooks';

export const MIN_CARD_WIDTH = 176;
export const CARDS_GAP = 8;

// The headline cards (the Total plus one per department). However many there are, they form as few rows as the width
// allows with every card readable: 8 across on a wide screen, 4 + 4 on a medium one, 3 + 3 + 2 on a narrow one - never a
// card squeezed until its name is cut off, never a row scrolling sideways. The count is whatever the backend returns, so
// it is never assumed here. Before the width is known (first paint, tests) plain CSS auto-fit is used.
export default function SummaryCardsGrid({ children }) {
  const count = React.Children.toArray(children).filter(Boolean).length;
  const [ref, , width] = useElementSize();
  const columns = balancedColumns({ count, width, minCard: MIN_CARD_WIDTH, gap: CARDS_GAP });
  return (
    <Box
      ref={ref}
      data-columns={columns || 'auto'}
      sx={{
        display: 'grid',
        gridTemplateColumns: columns ? `repeat(${columns}, minmax(0, 1fr))` : `repeat(auto-fit, minmax(${MIN_CARD_WIDTH}px, 1fr))`,
        gap: `${CARDS_GAP}px`,
        alignItems: 'stretch',
      }}
    >
      {children}
    </Box>
  );
}
